export interface ProductDescriptionProps {
  /** Ya resuelta en el idioma activo por `contentFor`. */
  description: string | undefined;
}

/**
 * La descripción del producto.
 *
 * ── Los saltos de línea se respetan ──────────────────────────────────
 * El texto lo escribe quien administra el catálogo en un `<textarea>`, y
 * ahí los párrafos se separan con Enter. Sin `whitespace-pre-line`, HTML
 * colapsa esos saltos y tres párrafos cuidados se pintan como un ladrillo
 * de texto.
 *
 * Es `pre-line` y no `pre`: los espacios de más —los que deja pegar desde
 * Word— sí se colapsan, que es lo que se quiere. Y sigue siendo texto
 * plano: nada de `dangerouslySetInnerHTML` sobre algo que se captura en
 * un formulario.
 *
 * ── `max-w` con medida ───────────────────────────────────────────────
 * Una línea de 120 caracteres se lee mal: el ojo pierde el renglón al
 * volver. El tope deja la columna alrededor de los 70.
 */
export function ProductDescription({ description }: ProductDescriptionProps) {
  if (!description) return null;

  return (
    <p className="max-w-prose whitespace-pre-line text-[15px] font-light leading-[1.65] text-ds-ink-2">
      {description}
    </p>
  );
}
